import React from "react";
import styled from "styled-components";

import { Context } from "@examspark/question-player";
import { Resource } from "@examspark/types";

import { Highlighter } from "../../utils/highlighter";
import { useExistingHighlights } from "../../utils/useHighlighter";
import { useLineReader } from "../../utils/useLineReader";
import HighlighterToolbar from "../common/tools/Highlighter";

const BorderedItemContexts = styled.div`
  flex: 1;
  padding: 1rem;
  overflow: auto;
  height: 100%;

  display: flex;
  flex-direction: column;

  border-right: solid 2px #ddd;
`;
const StyledContexts = styled.div`
  position: relative;
  flex: 1 1 auto;

  // do not add padding/border to our line reader divs
  // todo: this could be improved but I was trying to avoid
  // refactoring the whole dom/style layout here
  div + div:not([class*="line-reader]) {
    margin-top: 1em;
    padding-top: 1em;
    border-top: solid 1px #ddd;
  }
`;

type ItemContextSidebarProps = {
  contexts: Resource[];
};
const ItemContextSidebar = (props: ItemContextSidebarProps) => {
  const { contexts } = props;
  const { handleClick, containerRef } = useLineReader();

  return (
    <BorderedItemContexts>
      <StyledContexts onClick={handleClick} ref={containerRef}>
        {contexts?.map((ctx) => {
          return <ContextWrapper key={ctx.id} data={ctx} />;
        })}
      </StyledContexts>
    </BorderedItemContexts>
  );
};

export const ContextWrapper = (props: React.ComponentProps<typeof Context>) => {
  const highlighterRef = React.useRef<Highlighter | null>(null);
  const { onHighlighterInit } = useExistingHighlights();
  const { data } = props;

  return (
    <div
      style={{ position: "relative" }}
      ref={(el) => {
        if (el) {
          highlighterRef.current = new Highlighter(el);
          onHighlighterInit(data.id, highlighterRef.current);
        } else {
          highlighterRef.current = null;
        }
      }}
    >
      <HighlighterToolbar highlighterRef={highlighterRef} />
      <Context {...props} />
    </div>
  );
};

export default ItemContextSidebar;
